import { createReducer } from '@reduxjs/toolkit';
import {
  fetchCountSuccess,
  fetchCountFailure
} from '../../../../moderation-v2/comments-and-posts/state/actions/index';
import { clearNotifications } from '../actions/index';

const TOTAL_ITEMS_ON_PAGE = 20;

type TNotificationsReducer = ReturnType<typeof notificationsReducer>;

export const initialState = {
  comments: 0,
  posts: 0
};

const notificationsReducer = createReducer(initialState, {
  [fetchCountSuccess.type]: (state, { payload: { counts, polling, contentType } }) => {
    if (polling) {
      const { pending } = counts || {};
      state[contentType?.toLowerCase()] = pending || 0;
    }
  },
  [clearNotifications.type]: (state, { payload: { notificationType } }) => {
    const isValidNotificationType = Number.isInteger(state[notificationType]);

    if (isValidNotificationType) {
      state[notificationType] = 0;
    }
  }
});

export { notificationsReducer, TNotificationsReducer };
